// app/javascript/search.js
document.addEventListener('turbo:load', initSearch);
document.addEventListener('turbo:frame-load', initSearch);

function initSearch() {

    const searchInput = document.getElementById('search_input');
    const resultsContainer = document.getElementById('search_results');

    if (!searchInput) return;

    // Удали старые слушатели если есть
    searchInput.removeEventListener('input', handleSearch);

    searchInput.addEventListener('input', debounce(handleSearch, 300));

    function handleSearch(e) {
        const query = e.target.value.trim();

        if (query.length < 2) {
            resultsContainer.style.display = 'none';
            resultsContainer.innerHTML = '';
            return;
        }

        fetch(`/search?q=${encodeURIComponent(query)}`, {
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(response => response.json())
            .then(data => {
                displayResults(data.results);
            })
            .catch(error => console.error('Search error:', error));
    }

    function displayResults(results) {
        resultsContainer.innerHTML = '';

        if (!results.categories.length && !results.items.length && !results.resources.length) {
            resultsContainer.innerHTML = '<div class="list-group-item">Ничего не найдено</div>';
            resultsContainer.style.display = 'block';
            return;
        }

        let html = '';

        if (results.categories.length) {
            html += '<div class="list-group-item bg-light"><small class="text-muted">КАТЕГОРИИ</small></div>';
            results.categories.forEach(item => {
                html += `<a href="${item.path}" class="list-group-item list-group-item-action" data-turbo="true">
          <div class="d-flex w-100 justify-content-between">
            <span>${item.name}</span>
            <small class="badge bg-primary">категория</small>
          </div>
        </a>`;
            });
        }

        if (results.items.length) {
            html += '<div class="list-group-item bg-light"><small class="text-muted">ТОВАРЫ</small></div>';
            results.items.forEach(item => {
                html += `<a href="${item.path}" class="list-group-item list-group-item-action" data-turbo="true">
          <div class="d-flex w-100 justify-content-between">
            <span>${item.name}</span>
            <small class="badge bg-success">товар</small>
          </div>
        </a>`;
            });
        }

        if (results.resources.length) {
            html += '<div class="list-group-item bg-light"><small class="text-muted">ДОКУМЕНТЫ</small></div>';
            results.resources.forEach(item => {
                html += `<a href="${item.path}" class="list-group-item list-group-item-action" data-turbo="true">
          <div class="d-flex w-100 justify-content-between">
            <span>${item.name}</span>
            <small class="badge bg-info">документ</small>
          </div>
        </a>`;
            });
        }

        resultsContainer.innerHTML = html;
        resultsContainer.style.display = 'block';
    }

    document.addEventListener('click', function(e) {
        if (!e.target.closest('#search_input') && !e.target.closest('#search_results')) {
            resultsContainer.style.display = 'none';
        }
    });
}

function debounce(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}